import React from 'react';
import ContactAvailabilityDetailsPlanningPanel from './ContactAvailabilityDetailsPlanningPanel';

export default function AvailabilityDetails() {
    return (
        <div className={'content-section'}>
            <div className="content-container w-container">
                <ContactAvailabilityDetailsPlanningPanel />
            </div>
        </div>
    );
}
